import { useQuery } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { API_ERRORS } from '@/constants'
import { MarketShopSettingsModel } from '@/models'
import { getApiErrorStatus } from '@/utils'

export const getSettingsByTokenQueryKey = () => ['useGetSettingsByToken']

export const getSettingsByToken = async () => {
  const response = await marketShopAPI.get<MarketShopSettingsModel>(
    '/market-shop/settings-by-token',
  )
  return response.data
}

export interface UseGetSettingsByTokenProps {
  enabled?: boolean
}

export const useGetSettingsByToken = ({ enabled }: UseGetSettingsByTokenProps = {}) => {
  const result = useQuery({
    enabled,
    queryFn: () => getSettingsByToken(),
    queryKey: getSettingsByTokenQueryKey(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retryOnMount: false,
  })

  // NOTE: `getSettingsByToken` works in that way that if it returns any error, it means that flow is not resident-oriented
  // otherwise, if it succeeds, it means that flow is resident-oriented
  const status = getApiErrorStatus(result.error)
  const isResidentFlow = !!result.data?.id && status !== API_ERRORS.BAD_REQUEST && !result.isPending
  // NOTE: we derive a bad request error as not error, it's expected by the flow.
  // Since settings fetching with token that may fail due to buidling/resident token may be passed
  const isError = result.isError && status !== API_ERRORS.BAD_REQUEST

  return { ...result, isError, isResidentFlow }
}
